import { curveStepAfter } from 'd3-shape';
import '@d3fc/d3fc-element';
import { AnySelection, seriesSvgLine } from '@d3fc/d3fc-series';
import { deriveVwap } from 'widgets/fillsGraph/fillsGraphData';
import { deriveTime } from 'utils/components/TimeSeriesChart/TimeSeriesChartData';

export const vwapLine = seriesSvgLine()
    .crossValue(deriveTime)
    .mainValue(deriveVwap)
    .curve(curveStepAfter)
    .decorate((s: AnySelection) => s.classed('vwapLine', true));
